var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.e790dbfcf48e06548088f6cdd58b64cf.svg#b';
                    var viewUrl = 'sprites.e790dbfcf48e06548088f6cdd58b64cf.svg#view-b';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 27 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };